var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconControl48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_16522)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6.50269C33.9411 6.50269 42 14.5616 42 24.5027C42 34.4438 33.9411 42.5027 24 42.5027C14.0589 42.5027 6 34.4438 6 24.5027C6 14.5616 14.0589 6.50269 24 6.50269ZM37.851 28.1024L33.6019 28.1027C29.5281 28.1027 26.2256 31.4045 26.2256 35.4851L26.2264 38.6382C31.8799 37.7549 36.4364 33.5613 37.851 28.1024ZM21.138 38.5241L21.1385 35.4851C21.1385 31.4079 17.8278 28.1027 13.76 28.1027L10.149 28.1024C11.5102 33.3552 15.7806 37.4364 21.138 38.5241ZM24 10.195C17.5428 10.195 12.0847 14.4725 10.3047 20.3485H37.6953C35.9153 14.4725 30.4572 10.195 24 10.195Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 29.3367C25.8786 29.3367 27.4012 27.8141 27.4012 25.9358C27.4012 24.0576 25.8786 22.535 24.0004 22.535C22.1222 22.535 20.5996 24.0576 20.5996 25.9358C20.5996 27.8141 22.1222 29.3367 24.0004 29.3367Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_16522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconControl48);
export default __webpack_public_path__ + "static/media/pictogramBeaconControl48.009ee07cabdf587a7e98a2005c1983e0.svg";
export { ForwardRef as ReactComponent };